import { createAction } from 'redux-actions';

export const startAttachedFileSubmit = createAction('START_ATTACH_FILE_SUBMIT');

export const resolveAttachedFileSubmit = createAction('RESOLVE_ATTACH_FILE_SUBMIT');
